export default __webpack_public_path__ + "static/media/pdf.f9c0a547.png";